import Head from "next/head";
import React, { useState } from "react";
import { useEffect } from "react";
import { Button } from "../components/Button";
import { FinderResultCardType, FinderResultCardPropertyType } from "../types";
import styles from "./ResultCard.module.css";

export const ResultCardComponent = ({
  title,
  subtitle,
  logo,
  link,
  properties,
  body,
}: FinderResultCardType) => {
  const [visible, setVisible] = useState<boolean>(false);
  const [visibleProperties, setVisibleProperties] =
    useState<FinderResultCardPropertyType[]>(properties);

  const toggle = React.useCallback(() => {
    setVisible((visible) => !visible);
  }, [setVisible]);

  useEffect(() => {
    if (!properties) return;
    setVisibleProperties(visible ? properties : properties.slice(0, 6));
  }, [visible, properties]);

  let url;
  if (link) {
    try {
      url = new URL(link);
      url.searchParams.append("utm_source", "maakjestap.nl");
      url.searchParams.append("utm_medium", "referral");
    } catch (error) {
      console.log("not a valid url: " + link);
    }
  }
  url = url?.toString();

  return (
    <div className={styles.container}>
      {logo && (
        <Head>
          <link rel="preload" href={logo} as="image" key={logo} />
        </Head>
      )}

      <div className={styles.inner}>
        <div className={styles.header}>
          {logo && (
            <img src={logo} alt="logo" className={styles.logo} loading="lazy" />
          )}

          <div className={styles.titleWrapper}>
            {title && <h2 className={styles.title}>{title}</h2>}
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          </div>

          {link && (
            <div className={styles.link}>
              <Button
                icon="external"
                label="Bekijk opleiding"
                url={url}
                variation="primary"
                size="sm"
              />
            </div>
          )}
        </div>

        {Boolean(visibleProperties?.length) && (
          <ul className={styles.properties}>
            {visibleProperties.map(({ label, value }) => (
              <li key={label}>
                <span className={styles.label}>{label}</span>
                <span className={styles.value}>
                  {value?.replace(/€.*NaN/, "Prijs op aanvraag")}
                </span>
              </li>
            ))}
          </ul>
        )}

        {visible && <p className={styles.body}>{body}</p>}

        {link && (
          <div className={styles.linkMobile}>
            <Button
              icon="external"
              label="Bekijk opleiding"
              url={url}
              variation="primary"
              size="sm"
            />
          </div>
        )}

        <ToggleButton
          state={visible ? "show-less" : "show-more"}
          onClick={toggle}
        />
      </div>
    </div>
  );
};

export const ResultCard = React.memo(ResultCardComponent);

type ToggleButtonProps = {
  state: "show-more" | "show-less";
  onClick: () => void;
};

const ToggleButton = ({ state, onClick }: ToggleButtonProps) => (
  <button type="button" onClick={onClick} className={styles.toggleButton}>
    {state === "show-less" ? "- Minder informatie" : "+ Meer informatie"}
  </button>
);
